import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion"; // Animation
import config from "../config";

const LoginPage = () => {
  const { lang } = useParams(); // Récupère la langue de l'URL
  const navigate = useNavigate();
  const [userEmail, setUserEmail] = useState("");
  const [userPassword, setUserPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null); // Message de statut

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setLoading(true);
    setStatus("Connexion en cours...");

    try {
      const url_server = `${config.API_BASE_URL}/api/auth/login`;
      const response = await fetch(url_server, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",  // Permet d'envoyer et recevoir les cookies
        body: JSON.stringify({ userEmail, userPassword }),
      });

      if (!response.ok) {
        throw new Error("Réponse invalide du serveur");
      }

      const data = await response.json();
      console.log("Réponse du serveur:", data);

      if (data.isSuccess) {
        setStatus("Connexion réussie !");
        setTimeout(() => {
          if (data.role === "admin") {
            navigate(`/${lang}/ad-systeme`); // Rediriger l'admin
          } else {
            navigate(`/${lang}/`); // Rediriger utilisateur normal
          }
        }, 1000);
      } else {
        setError(data.message);
        setStatus("Échec de la connexion, veuillez réessayer.");
      }
    } catch (error) {
      setError("Une erreur est survenue, veuillez réessayer.");
      setStatus("Erreur de connexion, veuillez réessayer.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (status) {
      const timer = setTimeout(() => {
        setStatus(null);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [status]);

  return (
    <div className="relative min-h-screen flex flex-col justify-center items-center">
      {/* Message de statut */}
      <AnimatePresence>
        {status && (
          <motion.div
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -50 }}
            transition={{ duration: 0.5 }}
            className="absolute top-4 left-1/2 transform -translate-x-1/2 bg-deepblue text-light px-6 py-3 rounded-lg shadow-lg"
          >
            {status}
          </motion.div>
        )}
      </AnimatePresence>

      <div className="w-full md:w-2/3 lg:w-1/2 bg-light rounded-2xl shadow-lg p-8 flex flex-col space-y-6">
        <h2 className="text-3xl font-bold text-center text-dark mb-6">
          Connexion
        </h2>

        <form onSubmit={handleSubmit}>
          {/* Champ Email */}
          <div className="mb-4">
            <input
              type="email"
              className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:accent"
              placeholder="Email"
              value={userEmail}
              onChange={(e) => setUserEmail(e.target.value)}
              required
            />
          </div>

          {/* Champ Mot de passe */}
          <div className="mb-4">
            <input
              type="password"
              className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:accent"
              placeholder="Mot de passe"
              value={userPassword}
              onChange={(e) => setUserPassword(e.target.value)}
              required
            />
          </div>

          {/* Message d'erreur */}
          {error && <p className="text-red-500 text-sm text-center mb-4">{error}</p>}

          {/* Bouton de connexion */}
          <button
            type="submit"
            className={`w-full p-4 text-white rounded-lg font-semibold transition duration-300 ease-in-out transform ${
              loading ? "bg-gray-400 cursor-not-allowed" : "bg-accent hover:bg-deepblue"
            }`}
            disabled={loading}
          >
            {loading ? "Connexion en cours..." : "Se connecter"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
